import { CdkPortalOutlet } from '@angular/cdk/portal';
import { ChangeDetectionStrategy, Component, HostBinding, ViewEncapsulation } from '@angular/core';
import { modalAnimations } from '@df/ui/modal/modal-animations';
import { ModalContainerAbstract } from '@df/ui/modal/modal-container.abstract';

/**
 * Internal component that wraps user-provided modal content.
 * Animation is based on https://material.io/guidelines/motion/choreography.html.
 */
@Component({
    selector: 'modal-container',
    template: `<ng-template cdkPortalOutlet />`,
    styleUrl: './modal-container.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    animations: [modalAnimations.modalContainer],
    host: {
        class: 'modal-container',
        tabindex: '-1',
        'aria-modal': 'true',
        '[attr.id]': 'id',
        '[attr.role]': 'config.role',
        '[attr.aria-labelledby]': 'config.ariaLabel ? null : ariaLabelledBy',
        '[attr.aria-label]': 'config.ariaLabel',
        '[attr.aria-describedby]': 'config.ariaDescribedBy || null',
        '(@modalContainer.start)': 'onAnimationStart($event)',
        '(@modalContainer.done)': 'onAnimationDone($event)'
    },
    standalone: true,
    imports: [CdkPortalOutlet]
})
export class ModalContainerComponent extends ModalContainerAbstract {
    @HostBinding('@modalContainer') get getModalContainer(): any {
        return this.animationState;
    }
}
